import React from 'react'
import { cleanString } from 'utils/utils'
import { Stamp } from './style'

/**
 * @param {{brand: string}}
 */
export default ({ brand }) => <Stamp>Oferta { cleanString(brand?.toLowerCase(), {capitalizeAll: true})}</Stamp>
